<article class="icon">
   <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMin meet" viewBox="0 0 28 28">
      <use href="#bufferingAnim"></use>
   </svg>
</article>
